<template>
    <div class="preview_wrapper" style="overflow-y: auto;">

        <img v-if="!errorLoadImage && previewData.type === 'image'" :src="previewData.url" class="bg-img" @error="errorLoad"
            @load="loadingFile = false">

        <!-- HEADER -->
        <div class="preview_header" :class="{ 'hide_handles': hideHandles }">
            <!-- NAME -->
            <div class="preview_image_name">
                <span :title="previewData.name">{{ previewData.name }}</span>
            </div>
            <!-- ZOOM -->
            <div class="preview_image_zoom" v-if="previewData.type === 'image' || previewData.ext === 'pdf'" >
                <template v-if="previewData.ext === 'pdf' && pdfPageCount > 0">
                    <button class="zoomBtn" tabindex="-1" @click="pdfRef?.previousPage()" :disabled="pdfCurrentPage <= 1">‹</button>
                    <span>{{ pdfCurrentPage }} / {{ pdfPageCount }}</span>
                    <button class="zoomBtn" tabindex="-1" @click="pdfRef?.nextPage()" :disabled="pdfCurrentPage >= pdfPageCount">›</button>
                </template>
                <button class="zoomBtn" tabindex="-1" @click="handleZoom('decr', true)"
                    :disabled="errorLoadImage || loadingFile">-</button>
                <span>{{ Math.round(zoom * 100) }}%</span>
                <button class="zoomBtn" tabindex="-1" @click="handleZoom('incr', true)"
                    :disabled="errorLoadImage || loadingFile">+</button>
            </div>

            <!-- RIGHT BUTTON -->
            <div class="top-buttons">
                <template v-if="clientWidth >= 768">
                    <button class="close button-style" @click="openFile(previewData)">
                        <img src="@/assets/images/png/open.png" alt="open" title="open in new tab" width="16px">
                    </button>
                    <button class="close button-style" style="margin-left: 15px;"
                        @click="downloadFile(previewData?.path, `${previewData?.name}`)">
                        <img src="@/assets/images/svg/download_bottom_wrapper.svg" class="download_icon" alt="download"
                            title="download" width="16px">
                    </button>
                    <button v-if="props.isNewTab == false" class="close button-style" style="margin-left: 15px;" @click="$emit('close')">
                        <img src="@/assets/images/svg/delete.svg" />
                    </button>
                </template>
                <template v-else>
                    <DropDown :zIndex="999">
                        <template #button>
                            <button class="close button-style">
                                <img :ref="`my_dd_options`" src="@/assets/images/svg/verticalDropdownthreedots.svg"
                                    alt="options" title="actions" width="10px" class="verticalDots">
                            </button>
                        </template>
                        <template #options>
                            <DropDownOption @click="$refs[`my_dd_options`].click(), openFile(previewData)">

                                <button class="close button-style mr-10px">
                                    <img src="@/assets/images/png/open.png" alt="open" title="open in new tab"
                                        width="16px">
                                </button>
                                Open in new tab
                            </DropDownOption>
                            <DropDownOption
                                @click="$refs[`my_dd_options`].click(), downloadFile(previewData?.path, `${previewData?.name}`)"
                                style="margin-bottom:0px !important;">
                                <button class="close button-style mr-10px">
                                    <img src="@/assets/images/svg/download_bottom_wrapper.svg" class="download_icon"
                                        alt="download" title="download" width="16px">
                                </button>
                                Download
                            </DropDownOption>
                        </template>
                    </DropDown>
                    <button class="close button-style" style="margin-left: 15px;" @click="$emit('close')">
                        <img src="@/assets/images/svg/delete.svg" />
                    </button>
                </template>
            </div>
        </div>

        <div class="preview_container" @dblclick="previewData.type === 'image' ? resetPosition() : null"
            @mousewheel="!errorLoadImage ? handleZoom($event) : null" v-show="!loadingFile"
            @mouseup="previewData.type === 'image' ? handleMouseUp($event, '.preview_container .preview') : null"
            @mousedown="previewData.type === 'image' ? handleMouseDown($event, '.preview_container .preview') : null"
            @mousemove="previewData.type === 'image' ? handleMouseMove($event, '.preview_container .preview') : null"
            @touchstart="previewData.type === 'image' ? handleTouchStart($event, '.preview_container .preview') : null"
            @touchmove="previewData.type === 'image' ? handleTouchMove($event, '.preview_container .preview') : null"
            @touchend="previewData.type === 'image' ? handleTouchEnd($event, '.preview_container .preview') : null"
            @dragstart.prevent>
            <!-- <WasabiIamgeCompp
                v-if="!errorLoadImage && image.type === 'image'"
                :data="{ url: image.bgUrl ?? image.url }"
                class="bg-img"
                @error="errorLoad"
                @load="loadingFile = false"
            /> -->

            <!-- PREVIEW IMAGE -->
            <template v-if="!errorLoadImage && !isOversizedNonPdf">
                <!-- IMAGE -->
                <div v-if="previewData.type === 'image'" class="preview_image">
                    <img ref="imageRef" :src="previewData.url" @load="loadingFile = false, resetPosition()"
                        :alt="previewData.alt" :title="previewData.filename" class="preview" @error="errorLoad">
                </div>

                <!-- VIDEO -->
                <video v-else-if="previewData.type === 'video'" ref="videoRef" :title="previewData.title"
                    class="preview" controls @loadeddata="loadingFile = false">
                    <source :src="previewData.url" :alt="previewData.alt" @error="errorLoad">
                    Your browser does not support the video tag.
                </video>

                <!-- Audio -->
                <audio v-else-if="previewData.type === 'audio'" ref="audioRef" :title="previewData.title"
                    class="preview" controls @loadeddata="loadingFile = false">
                    <source :src="previewData.url" :alt="previewData.alt" @error="errorLoad">
                </audio>

                <div v-else-if="previewData.type === 'pdf' || previewData.ext?.includes('pdf') && previewData.url"
                    class="pdf-scroll-container">
                    <PdfViewer
                    ref="pdfRef"
                    :key="previewData.key || previewData.id || previewData.path || previewData.url"
                    :source="previewData.url"
                    :file-size="previewData.size"
                    @error="errorLoad"
                    @loadedData="loadingFile = false"
                    />                
                </div>




                <TextPreviewer v-else-if="['js', 'json', 'txt']?.includes(previewData.ext)"
                    :key="previewData.key || previewData.id || previewData.path || previewData.url"
                    class="preview"
                    :url="previewData.url" @load="loadingFile = false" @error="errorLoad" />

                <HtmlPreviewer v-else-if="previewData.ext === 'html'" class="preview" :url="previewData.url"
                    :key="previewData.key || previewData.id || previewData.path || previewData.url" @load="loadingFile = false" @error="errorLoad" />

                <DocsPreviewer v-else-if="['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx']?.includes(previewData.ext)"
                    :key="previewData.key || previewData.id || previewData.path || previewData.url"
                    class="preview" :url="previewData.url" @load="loadingFile = false" @error="errorLoad" />

                <!-- OTHER FILES -->
                <img v-else :src="previewData.url" :alt="previewData.alt" @load="loadingFile = false"
                    :title="previewData.title" class="preview" @error="errorLoad">
            </template>

            <!-- ON PREVIEW ERROR -->
            <template v-else-if="isOversizedNonPdf">
                <div class="no_preview_available oversized-preview">
                    <span>File lớn hơn 25 MB, vui lòng tải xuống để xem.</span>
                    <button class="oversized-download" @click="downloadFile(previewData?.path || previewData?.url, previewData?.name)">
                        Tải xuống
                    </button>
                </div>
            </template>

            <!-- ON PREVIEW ERROR -->
            <template v-else>
                <div v-if="!defaultFailImage" class="no_preview_available">
                    <span>No preview available</span>
                </div>
                <img v-else :src="defaultFailImage" :alt="previewData.alt" :title="previewData.title" class="preview"
                    @error="errorLoad">
            </template>
        </div>

        <!-- LOADING -->
        <div class="loading" v-if="loadingFile">
            <MacLoader />
        </div>
    </div>
</template>

<script setup>
import { dragHelper } from "@/components/organisms/ImagePreviewer/hepler";
import { defineProps, defineEmits, inject, ref, watch, computed } from "vue";
import DropDown from '@/components/molecules/DropDown/DropDown.vue';
import DropDownOption from '@/components/molecules/DropDownOption/DropDownOption.vue';

// import WasabiIamgeCompp from "@/components/atom/WasabiIamgeCompp/WasabiIamgeCompp.vue";
import TextPreviewer from "@/components/molecules/TextPreviewer/TextPreviewer.vue";
import HtmlPreviewer from "@/components/molecules/HtmlPreviewer/HtmlPreviewer.vue";
import MacLoader from "../MacLoader/MacLoader.vue";
import { download } from "@/utils/StorageOprations/download";
import { storageHelper } from "@/composable/commonFunction";
import PdfViewer from "../Attachments/PdfViewer.vue";
import DocsPreviewer from "@/components/molecules/DocsPreviewer/DocsPreviewer.vue";
import * as env from '@/config/env';

const { getStorageImage, getStorageImageServerStorage } = storageHelper();
defineEmits(["close"]);
const companyId = inject("$companyId");
const clientWidth = inject("$clientWidth");
const props = defineProps({
    image: {
        type: Object,
        required: true
    },
    downloadFun: {
        type: Function,
        required: false
    },
	isNewTab: {
        type: Boolean,
        default: false
    },
})

const { handleMouseUp, handleMouseDown, handleMouseMove, handleTouchEnd, handleTouchStart, handleTouchMove, setScale, resetOffsets } = dragHelper();

const defaultFailImage = inject("defaultFailImage")
const hideHandles = inject("hideHandles")
const errorLoadImage = ref(false);
const previewData = ref(props.image);

const defaultScale = computed(() => clientWidth?.value >= 768 ? 0.6 : 1);
const zoom = ref(defaultScale.value);
const loadingFile = ref(true);
const imageRef = ref(null);
const videoRef = ref(null);
const audioRef = ref(null);
const resolvedUrl = ref("");
const pdfRef = ref(null);
const pdfCurrentPage = computed(() => pdfRef.value?.currentPage || 1);
const pdfPageCount = computed(() => pdfRef.value?.pageCount || 0);
const NON_PDF_PREVIEW_LIMIT = 25 * 1024 * 1024;

function parseFileSize(size) {
    if (typeof size === "number") return size;
    const normalized = String(size || "").trim().toLowerCase();
    const value = Number.parseFloat(normalized.replace(/,/g, ""));
    if (!Number.isFinite(value)) return 0;
    if (normalized.includes("gb")) return value * 1024 * 1024 * 1024;
    if (normalized.includes("mb")) return value * 1024 * 1024;
    if (normalized.includes("kb")) return value * 1024;
    return value;
}

function isPdfFile(file) {
    return file?.type === "pdf" || String(file?.ext || file?.extension || "").toLowerCase().includes("pdf");
}

const isOversizedNonPdf = computed(() => (
    !isPdfFile(previewData.value) && parseFileSize(previewData.value?.size) > NON_PDF_PREVIEW_LIMIT
));
watch(
    () => props.image,
    async (val) => {
        loadingFile.value = true;
        errorLoadImage.value = false;
        previewData.value = {};

        if (!val || !val.type) {
            errorLoadImage.value = true;
            loadingFile.value = false;
            return;
        }

        const base = JSON.parse(JSON.stringify(val));

        if (!isPdfFile(base) && parseFileSize(base.size) > NON_PDF_PREVIEW_LIMIT) {
            previewData.value = base;
            resolvedUrl.value = "";
            loadingFile.value = false;
            return;
        }

        try {
            const fileKey = base.path || base.url;
            if (!fileKey) {
                throw new Error("Không có fileKey (path/url) để lấy file từ storage");
            }

            let finalUrl = base.bgUrl || (/^https?:\/\//.test(base.url || "") ? base.url : "");

            if (!finalUrl || !/^https?:\/\//.test(finalUrl)) {
                if (!env?.STORAGE_TYPE || env.STORAGE_TYPE !== "server") {
                    const res = await getStorageImage({
                        companyId: companyId.value,
                        data: { url: fileKey },
                    });
                    finalUrl = res;
                } else {
                    const res = await getStorageImageServerStorage({
                        filePath: fileKey,
                        companyId: companyId.value,
                        tuhumbnailSize: null,
                    });

                    finalUrl = res?.downloadUrl || res?.url;
                }
            }

            if (!finalUrl) {
                throw new Error("Không resolve được URL từ storage");
            }

            previewData.value = {
                ...base,
                url: finalUrl,
            };
            resolvedUrl.value = finalUrl;

            errorLoadImage.value = false;
        } catch (err) {
            errorLoadImage.value = true;
        } finally {
            loadingFile.value = false;
        }
    },
    { immediate: true, deep: true }
);

function handleZoom(e, manual = false) {
    if (previewData.value.ext === "pdf") {

        if (manual && e === "incr") {
            pdfRef.value?.zoomIn();
        }

        if (manual && e === "decr") {
            pdfRef.value?.zoomOut();
        }
        zoom.value = pdfRef.value?.scale || zoom.value;
        return;
    }
    if (previewData.value.type !== "image") return;

    let element;
    if (!manual) {
        element = e.target.classList.contains("preview")
            ? e.target
            : e.target.querySelector("img.preview");
    } else {
        element = document.querySelector(".preview_container img.preview");
    }

    if (!element) return;

    const tmpZoom = Number(element.style.scale) || defaultScale.value;
    const scaleJump = 0.05;

    element.style.scale =
        (!manual && e.deltaY > 0) || (manual && e === "decr")
            ? tmpZoom > scaleJump
                ? tmpZoom - scaleJump
                : scaleJump
            : tmpZoom < 5
                ? tmpZoom + scaleJump
                : 5;

    zoom.value = element.style.scale;
    setScale(zoom.value);
}

function resetPosition() {
    if (previewData.value.type !== "image") return;

    const element = document.querySelector(".preview_container img.preview");
    if (!element) return;

    element.style.position = "relative";
    element.style.transform = "translate(0px, 0px)";
    element.style.scale = defaultScale.value;

    setScale(defaultScale.value);
    resetOffsets();
    zoom.value = defaultScale.value;
}

async function openFile(file) {
    try {
        window.open(file.url, "_blank");
    } catch (error) {
        console.error("Failed to open file:", error.message);
    }
}

async function downloadFile(url, name) {
    try {
        let downloadUrl;

        if (!env?.STORAGE_TYPE || env.STORAGE_TYPE !== 'server') {
            const res = await getStorageImage({
                companyId: companyId.value,
                data: { url: url },
            });

            if (res) {
                downloadUrl = res;
            } else {
                console.error('getStorageImage returned an invalid response:', res);
                return;
            }
        } else {
            const res = await getStorageImageServerStorage({
                filePath: url,
                companyId: companyId.value,
                tuhumbnailSize: null,
            });

            if (res?.downloadUrl) {
                downloadUrl = res.downloadUrl;
            } else {
                console.error('getStorageImageServerStorage returned an invalid response:', res);
                return;
            }
        }

        await download(downloadUrl, name);
    } catch (error) {
        console.error('Download failed:', error.message);
    }
}

function errorLoad() {
    errorLoadImage.value = true;
    loadingFile.value = false;
}

</script>

<style lang="css" scoped>
@import url("./style.css");
.pdf-scroll-container {
    margin-top: 65px;
    height: calc(100dvh - 65px);
    width: 100%;
    overflow-y: auto;
    position: relative;
}
</style>
